const onInvoiceListPageMatch = () => {
  const waitForPageLoad = setInterval(() => {
    const pageContent = document.querySelector('#invoiceList')
    if (pageContent) {
      clearInterval(waitForPageLoad)

      const dropdownButton = document.querySelector('.DropdownButton')
      const existingButtonWrapper = document.querySelector('.buttonWrapper')
      if (dropdownButton && !existingButtonWrapper) {
        const buttonWrapper = document.createElement('div')
        buttonWrapper.className = 'buttonWrapper'
        buttonWrapper.style.display = 'flex'
        buttonWrapper.style.flexDirection = 'row'
        buttonWrapper.style.gap = '10px'

        const clonedDropdownButtonChecked = dropdownButton.cloneNode(true)
        clonedDropdownButtonChecked.textContent = 'Zu kontieren'

        const clonedDropdownButtonManagerApproval= dropdownButton.cloneNode(true)
        clonedDropdownButtonManagerApproval.textContent = 'Freigabe durch Manager'

        const clonedDropdownButtonApproval = dropdownButton.cloneNode(true)
        clonedDropdownButtonApproval.textContent = 'Freizugeben'

        dropdownButton.parentNode.insertBefore(
          buttonWrapper,
          dropdownButton.nextSibling
        )
        buttonWrapper.appendChild(dropdownButton)
        buttonWrapper.appendChild(clonedDropdownButtonApproval)
        buttonWrapper.appendChild(clonedDropdownButtonManagerApproval)
        buttonWrapper.appendChild(clonedDropdownButtonChecked)

        clonedDropdownButtonChecked.addEventListener('click', () => {
          const url = new URL(window.location.href)
          url.searchParams.set('state', 'NEW_CHECKED')
          window.history.pushState({}, '', url)
          window.location.reload()
        })

        clonedDropdownButtonApproval.addEventListener('click', () => {
          const url = new URL(window.location.href)
          url.searchParams.set('state', 'NEW_UNCHECKED')
          window.history.pushState({}, '', url)
          window.location.reload()
        })

        clonedDropdownButtonManagerApproval.addEventListener('click', () => {
          const url = new URL(window.location.href)
          url.searchParams.set('state', 'MANAGER_APPROVAL_REQUIRED')
          window.history.pushState({}, '', url)
          window.location.reload()
        })
      }
    }
  }, 500)
}